module.exports = __webpack_public_path__ + "static/media/ibfe-online-n.e3b364dc.svg";